var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "error" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c(
        "main",
        [
          _vm._l(_vm.errorMessages, function(message, index) {
            return _c("div", { key: "error-" + index }, [
              _vm._v(_vm._s(message))
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "toplink" }, [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.toLogin()
                  }
                }
              },
              [_vm._v("ログイン画面へ戻る")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-448a3664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448a3664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/Error.vue
// module id = null
// module chunks = 